// Card-product "Stone Colour" quick view — self-contained, no dependency
// on error-cart-drawer.js. Triggered by .card-stone-swatch (card-product.liquid).
(function () {
    "use strict";

    function runInjectedScripts(root) {
        root.querySelectorAll("script").forEach((oldScript) => {
            const newScript = document.createElement("script");
            for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
        });
    }

    function initScrollIndicators(root) {
        (root || document).querySelectorAll(".scroll1").forEach((el) => {
            if (el.dataset.kyScrollInit) return;
            el.dataset.kyScrollInit = "1";

            const indicator = document.createElement("div");
            indicator.className = "error-scroll-indicator";
            const thumb = document.createElement("div");
            thumb.className = "error-scroll-thumb";
            indicator.appendChild(thumb);
            el.insertAdjacentElement("afterend", indicator);

            function update() {
                const scrollable = el.scrollWidth - el.clientWidth;
                if (scrollable < 2) { indicator.hidden = true; return; }
                indicator.hidden = false;

                const trackW = indicator.clientWidth || el.clientWidth;
                const thumbW = Math.max(24, (el.clientWidth / el.scrollWidth) * trackW);
                const maxLeft = trackW - thumbW;
                const left = (el.scrollLeft / scrollable) * maxLeft;

                thumb.style.width = thumbW + "px";
                thumb.style.transform = "translateX(" + left + "px)";
            }

            el.addEventListener("scroll", update, { passive: true });
            new ResizeObserver(update).observe(el);
            update();
        });
    }

    function getOrCreateModal() {
        if (!document.getElementById("error-cpqv-backdrop")) {
            const bd = document.createElement("div");
            bd.id = "error-cpqv-backdrop";
            bd.className = "error-cpqv-backdrop";
            bd.addEventListener("click", closeModal);
            document.body.appendChild(bd);
        }

        let modal = document.getElementById("error-cpqv-modal");
        if (!modal) {
            modal = document.createElement("div");
            modal.id = "error-cpqv-modal";
            modal.className = "error-cpqv-modal";
            modal.setAttribute("hidden", "");
            modal.innerHTML = `
                <div class="error-cpqv-modal__box">
                    <button class="error-cpqv-modal__close" type="button" aria-label="Close">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 4L4 12M4 4l8 8" stroke="#5B5B5B" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </button>
                    <div class="error-cpqv-modal__body"></div>
                </div>`;
            document.body.appendChild(modal);
            modal.querySelector(".error-cpqv-modal__close").addEventListener("click", closeModal);
            // .error-cpqv-modal covers the full viewport (pointer-events:auto
            // when open) and sits above #error-cpqv-backdrop, so clicks in the
            // empty area around the box never reach the backdrop's own
            // listener — close here whenever the click lands on the modal
            // background itself, not one of its descendants (the box).
            modal.addEventListener("click", (e) => {
                if (e.target === modal) closeModal();
            });
        }
        return modal;
    }

    function openModalShell(modal) {
        modal.removeAttribute("hidden");
        const bd = document.getElementById("error-cpqv-backdrop");
        if (bd) bd.classList.add("is-open");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        // same idea as the header disappearing while a scroll-locked overlay
        // is open — hide the desktop filter bar + subcategory nav too, since
        // they otherwise stay floating above the dimmed backdrop
        document.body.classList.add("error-cpqv-modal-open");
        // next frame so the transform transition actually animates in
        requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add("is-open")));
    }

    function closeModal() {
        const modal = document.getElementById("error-cpqv-modal");
        const bd = document.getElementById("error-cpqv-backdrop");
        if (modal) modal.classList.remove("is-open");
        if (bd) bd.classList.remove("is-open");
        document.body.classList.remove("error-cpqv-modal-open");
        setTimeout(() => {
            if (modal) modal.setAttribute("hidden", "");
            // Popup opened from inside the cart drawer: the drawer still owns
            // the scroll lock, so leave it in place. (Checked at close time —
            // the drawer may also open right after an add, and it sets its own
            // lock when it does.)
            if (document.querySelector("error-cart-drawer.is-open")) return;
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        }, 360);
    }

    // Once an add goes through, the popup has done its job and gets out of the
    // way so the cart drawer (which opens off the same cartUpdate) is visible.
    // A no-op when the popup isn't open.
    function closeModalIfOpen() {
        const modal = document.getElementById("error-cpqv-modal");
        if (modal && modal.classList.contains("is-open")) closeModal();
    }

    // Cart line edit ("Update") dispatches this itself, below.
    document.addEventListener("custom:cart:added", closeModalIfOpen);

    // "Add to Cart" goes through product-form.js, which never fires
    // custom:cart:added — it publishes cartUpdate only after /cart/add
    // succeeded (errors return before it). error-cart-drawer.js opens the
    // drawer off this same event.
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source === "product-form") closeModalIfOpen();
        });
    }

    // editOpts (cart line edit mode): { key, qty, variantId, properties }.
    // Same popup, but the footer shows "Update" instead of "Add to Cart" /
    // "View All Details", and the shopper's current variant is preselected.
    async function openCardProductQuickView(handle, preselectValue, editOpts) {
        const modal = getOrCreateModal();
        const body = modal.querySelector(".error-cpqv-modal__body");
        body.innerHTML = `<div class="error-vedit__loading"><span class="error-spinner error-spinner--lg"></span></div>`;
        openModalShell(modal);

        try {
            const variantParam = editOpts && editOpts.variantId ? `variant=${editOpts.variantId}&` : "";
            const res = await fetch(`/products/${handle}?${variantParam}sections=error-card-product-quick-view`);
            const data = await res.json();
            const html = data["error-card-product-quick-view"];
            if (!html) throw new Error("no error-card-product-quick-view section");
            body.innerHTML = html;
            runInjectedScripts(body);
            initHandlers(body, preselectValue, editOpts);
        } catch (e) {
            console.warn("[Error CPQV] failed:", e.message);
            closeModal();
        }
    }

    // Desktop (≥750px, side-by-side layout): the info column should never
    // grow the popup taller than the image column — it should match the
    // image's actual rendered height and scroll internally instead. CSS
    // alone can't cap one flex item's height to a sibling's, so measure
    // the image wrap's real height here and keep it in sync as it
    // changes (image load, window resize).
    function syncInfoHeight(root) {
        const imgWrap = root.querySelector(".error-qv__img-wrap");
        const info = root.querySelector(".error-qv__info");
        if (!imgWrap || !info) return;

        const apply = () => {
            if (window.innerWidth < 750) {
                info.style.maxHeight = "";
                return;
            }
            info.style.maxHeight = imgWrap.offsetHeight + "px";
        };

        apply();
        const observer = new ResizeObserver(apply);
        observer.observe(imgWrap);
        window.addEventListener("resize", apply);

        // The modal's whole body gets replaced on every open (a new
        // product's HTML) — tear down the previous run's observer/
        // listener so they don't pile up across repeated opens.
        if (window._errorCpqvSyncCleanup) window._errorCpqvSyncCleanup();
        window._errorCpqvSyncCleanup = () => {
            observer.disconnect();
            window.removeEventListener("resize", apply);
        };
    }

    // "Get it by 24 - 26 October" — same range/format as the delivery_time
    // script in sections/main-product.liquid (aaj + 5 se aaj + 7 din).
    // Wo script sirf product page par chalti hai, isliye yahan alag se.
    function fillShipDate(root) {
        const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
            "August", "September", "October", "November", "December"];
        const today = new Date();
        const start = new Date(today);
        start.setDate(today.getDate() + 5);
        const end = new Date(today);
        end.setDate(today.getDate() + 7);

        const text = start.getMonth() === end.getMonth()
            ? `${start.getDate()} - ${end.getDate()} ${MONTHS[end.getMonth()]}`
            : `${start.getDate()} ${MONTHS[start.getMonth()]} - ${end.getDate()} ${MONTHS[end.getMonth()]}`;
        root.querySelectorAll("[data-cpqv-ship-date]").forEach((el) => (el.textContent = text));
    }

    // Horizontal list ka smooth scroll — ek hi rAF animation se:
    //  • desktop mouse wheel (vertical wheel → horizontal, eased)
    //  • mouse drag (1:1 follow) + chhodne par momentum (dheere ruke)
    //  • scrollToX() — selected pill tak eased scroll
    // CSS scroll-behavior:smooth yahan use NAHI hota (har scrollLeft set par
    // naya animation shuru karke jhatka deta tha). Touch par native swipe.
    function enableSmoothScroll(el) {
        if (!el || el._cpqvSmooth) return el && el._cpqvSmooth;

        const max = () => Math.max(0, el.scrollWidth - el.clientWidth);
        const clamp = (v) => Math.min(max(), Math.max(0, v));
        let target = el.scrollLeft;
        let rafId = null;

        // target ki taraf easing (lerp) — wheel aur scrollToX dono yahi use karte hain
        const animate = () => {
            const diff = target - el.scrollLeft;
            if (Math.abs(diff) < 0.5) {
                el.scrollLeft = target;
                rafId = null;
                return;
            }
            el.scrollLeft += diff * 0.18;
            rafId = requestAnimationFrame(animate);
        };
        const run = () => { if (!rafId) rafId = requestAnimationFrame(animate); };
        const stopAnim = () => { if (rafId) cancelAnimationFrame(rafId); rafId = null; };

        // Mouse wheel: sirf tab hijack karo jab list sach me scroll ho sakti ho
        el.addEventListener("wheel", (e) => {
            if (max() <= 0) return;
            const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
            const next = clamp((rafId ? target : el.scrollLeft) + delta);
            // kinare par pahunch gaye to page/popup ko normal scroll hone do
            if (next === (rafId ? target : el.scrollLeft)) return;
            e.preventDefault();
            target = next;
            run();
        }, { passive: false });

        // Mouse drag + momentum
        let down = false, dragged = false, startX = 0, startScroll = 0;
        let lastX = 0, lastT = 0, velocity = 0, momentumId = null;

        const stopMomentum = () => { if (momentumId) cancelAnimationFrame(momentumId); momentumId = null; };

        el.addEventListener("pointerdown", (e) => {
            if (e.pointerType !== "mouse" || e.button !== 0) return;
            // list fits (no overflow) — leave clicks alone, nothing to drag
            if (max() <= 0) return;
            stopAnim();
            stopMomentum();
            down = true;
            dragged = false;
            startX = lastX = e.clientX;
            startScroll = el.scrollLeft;
            lastT = performance.now();
            velocity = 0;
        });
        el.addEventListener("pointermove", (e) => {
            if (!down) return;
            const dx = e.clientX - startX;
            if (!dragged && Math.abs(dx) > 5) {
                dragged = true;
                el.classList.add("is-dragging");
                el.setPointerCapture(e.pointerId);
            }
            if (!dragged) return;
            const now = performance.now();
            const dt = Math.max(1, now - lastT);
            velocity = (e.clientX - lastX) / dt; // px per ms
            lastX = e.clientX;
            lastT = now;
            el.scrollLeft = startScroll - dx;
        });
        const release = () => {
            if (!down) return;
            down = false;
            el.classList.remove("is-dragging");
            if (!dragged) return;
            // momentum: velocity dheere-dheere kam
            let v = -velocity * 16; // px per frame
            const step = () => {
                if (Math.abs(v) < 0.3) { momentumId = null; target = el.scrollLeft; return; }
                const before = el.scrollLeft;
                el.scrollLeft = clamp(before + v);
                if (el.scrollLeft === before) { momentumId = null; target = el.scrollLeft; return; }
                v *= 0.92;
                momentumId = requestAnimationFrame(step);
            };
            momentumId = requestAnimationFrame(step);
        };
        el.addEventListener("pointerup", release);
        el.addEventListener("pointercancel", release);
        el.addEventListener("click", (e) => {
            if (!dragged) return;
            e.preventDefault();
            e.stopPropagation();
            dragged = false;
        }, true);

        // Touch / trackpad ka native scroll — target ko sync rakho
        el.addEventListener("scroll", () => {
            if (!rafId && !down && !momentumId) target = el.scrollLeft;
        }, { passive: true });

        const api = {
            scrollToX(x) {
                stopMomentum();
                target = clamp(x);
                run();
            },
        };
        el._cpqvSmooth = api;
        return api;
    }

    // Ring Size pills: "Select Size: 4" label update + selected pill view me
    function initRingSizes(root) {
        const wrap = root.querySelector("[data-cpqv-sizes]");
        if (!wrap) return;
        const list = wrap.querySelector("[data-cpqv-sizes-list]");
        const valueEl = wrap.querySelector("[data-cpqv-size-value]");
        const smooth = enableSmoothScroll(list);

        const sync = (scroll) => {
            const checked = wrap.querySelector(".error-cpqv__size-input:checked");
            if (valueEl) valueEl.textContent = checked ? checked.value : "";
            if (checked) {
                const err = wrap.querySelector(".ring-size-picker__error");
                if (err) err.hidden = true;
                if (scroll && list && smooth) {
                    // pill ab .error-cpqv__size wrapper me hai — offsetLeft
                    // wrapper se relative aata, isliye rect se nikaalo
                    const item = checked.closest(".error-cpqv__size") || checked.nextElementSibling;
                    if (item) {
                        const x = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
                        smooth.scrollToX(x - 20);
                    }
                }
            }
        };
        wrap.querySelectorAll(".error-cpqv__size-input").forEach((r) =>
            r.addEventListener("change", () => sync(false))
        );
        root._cpqvSyncRingSize = sync;
        sync(false);
    }

    function initHandlers(body, preselectValue, editOpts) {
        initScrollIndicators(body);
        syncInfoHeight(body);
        fillShipDate(body);
        initRingSizes(body);
        // Variant pill rows (Ring size, Carat, ...) — desktop mouse drag/wheel
        // scroll like the product page's enablePillScroll (main-product.liquid)
        body.querySelectorAll(".product-form__input--pill .input_inner, .input_inner.scroll1")
            .forEach((el) => enableSmoothScroll(el));

        // This button is injected after page load, so wishlist.js's own
        // DOMContentLoaded/wishlist:updated sync never sees it — match its
        // .active state against localStorage right here.
        try {
            const list = JSON.parse(localStorage.getItem("wishlist") || "[]");
            body.querySelectorAll(".wishlist_button").forEach((btn) => {
                btn.classList.toggle(
                    "active",
                    list.some((i) => i.productVariant === btn.dataset.productVariantId)
                );
            });
        } catch {}

        let variants = [], media = [];
        try {
            const dataEl = body.querySelector("#error-cpqv-data");
            if (dataEl) {
                const parsed = JSON.parse(dataEl.textContent);
                variants = parsed.variants || [];
                media = parsed.media || [];
            }
        } catch {}

        // Same rule the product page uses (product-media-gallery.liquid +
        // assets/variant_change.js): an image whose alt text matches a real
        // variant option value only shows for that value — everything else
        // (mood/lifestyle shots with no matching alt) always stays visible.
        // Photo alt text only carries the colour ("Yellow Gold"), not the karat
        // ("14k Yellow Gold") — same handling as variant_change.js.
        const stripKarat = (v) => v.replace(/^\d+k\s+/, "");
        const allValues = new Set();
        variants.forEach(v => {
            [v.option1, v.option2, v.option3].forEach(o => {
                if (!o) return;
                const val = String(o).trim().toLowerCase();
                allValues.add(val);
                allValues.add(stripKarat(val));
            });
        });

        const fmt = (amount) => {
            if (window.Shopify?.formatMoney) {
                return window.Shopify.formatMoney(
                    amount,
                    window.money_format || window.Shopify.money_format || "${{amount}}"
                );
            }
            return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
                style: "currency",
                currency: window.Shopify?.currency?.active || "USD",
                maximumFractionDigits: 0,
            }).format((amount || 0) / 100);
        };
        const grid = body.querySelector("#error-cpqv-grid");
        const swiperEl = body.querySelector("#error-cpqv-swiper");
        const priceRow = body.querySelector("#error-cpqv-price");
        const viewDetailsBtn = body.querySelector("#error-cpqv-view-details");
        const variantIdInput = body.querySelector("#error-cpqv-variant-id");
        const addToCartBtn = body.querySelector("#error-cpqv-add-to-cart");

        // Shared so it can run both from applyValue() (products with
        // variant options) and standalone for products with no options at
        // all — applyValue() never used to run for those, which meant the
        // swiper was never initialized for the vast majority of products.
        function initSwiperInstance() {
            if (!swiperEl) return;
            // Deferred a frame: Swiper reads the container's actual layout
            // width at init time, and right after open the popup's slide-up/
            // scale-in transition may not have settled yet — measuring
            // mid-transition was producing a wrong (sometimes zero) width
            // and a broken swiper.
            requestAnimationFrame(() => {
                if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
                swiperEl.classList.remove("swiper-initialized");
                if (window.globalSwiperManager) window.globalSwiperManager.initSwiper(swiperEl);

                // globalSwiperManager (swiper-manager.js) only wires up
                // navigation for a fixed list of known data-swiper-type
                // values — "cpqv" isn't one of them, so it builds the
                // Swiper instance with no nextEl/prevEl at all and these
                // arrows sit unconnected. Wire them here instead of
                // touching that shared file. .onclick (not addEventListener)
                // so re-running this on every swatch change replaces the
                // old handler rather than stacking a new one on top.
                const nextBtn = swiperEl.querySelector(".swiper-button-next");
                const prevBtn = swiperEl.querySelector(".swiper-button-prev");
                if (nextBtn) nextBtn.onclick = () => swiperEl.swiper?.slideNext();
                if (prevBtn) prevBtn.onclick = () => swiperEl.swiper?.slidePrev();
            });
        }

        // One container per product option now (Material, Stone Colour,
        // ... as a <fieldset> of pills; Carat as a
        // .product-form__input--dropdown, matching
        // snippets/product-variant-picker.liquid) — read whichever
        // input/select is checked/selected in each, in DOM order, which
        // matches option1/2/3 order since these come from
        // product.options_with_values in that same order.
        // [class*="variant-picker-"] excludes the Ring Size / Bracelet
        // Size dropdowns, which use the same .product-form__input--dropdown
        // shell but are line-item properties, not variant options — they
        // don't belong in the variant-match combination below.
        function optionContainers() {
            return body.querySelectorAll('fieldset, [class*="variant-picker-"].product-form__input--dropdown');
        }

        function getSelectedValues() {
            return Array.from(optionContainers())
                .map(el => el.querySelector('input[type="radio"]:checked, select'))
                .filter(Boolean)
                .map(r => String(r.value).trim());
        }

        function updateSelectedLabels() {
            optionContainers().forEach(el => {
                const checked = el.querySelector('input[type="radio"]:checked, select');
                const label = el.querySelector("[data-selected-value], .custom-select__value");
                if (checked && label) label.textContent = checked.value;
            });
        }

        let lastAppliedKey = null;

        const applyValue = () => {
            const selectedValues = getSelectedValues();
            const key = selectedValues.join("|").toLowerCase();
            // skip redundant destroy+rebuild cycles for the combination
            // that's already applied — repeated calls were the main source
            // of the swiper feeling janky / occasionally failing to reinit
            if (key === lastAppliedKey) return;
            lastAppliedKey = key;

            updateSelectedLabels();

            const selectedLower = new Set();
            selectedValues.forEach(v => {
                const val = v.toLowerCase();
                selectedLower.add(val);
                const color = stripKarat(val);
                selectedLower.add(color);
                if (color === "platinum") selectedLower.add("white gold");
            });
            let visibleMedia = media.filter(m => {
                const a = String(m.alt || "").trim().toLowerCase();
                if (!a || !allValues.has(a)) return true;
                return selectedLower.has(a);
            });
            // Some products tag every image per colour with no generic/
            // untagged fallback shot — if the selected colour happens to
            // have no matching image, that filter can come back empty.
            // Falling back to showing everything (rather than skipping the
            // whole rebuild) is what keeps the swiper from ending up
            // un-initialized and non-functional for that product.
            if (!visibleMedia.length) visibleMedia = media;

            if (grid) {
                grid.innerHTML = visibleMedia.map(m =>
                    `<img class="error-cpqv__grid-img" src="${m.src}" alt="" width="500" height="500" loading="lazy">`
                ).join("");
            }
            if (swiperEl) {
                const wrapperEl = swiperEl.querySelector(".swiper-wrapper");
                if (wrapperEl) {
                    wrapperEl.innerHTML = visibleMedia.map(m =>
                        `<div class="swiper-slide"><img src="${m.src}" alt="" width="500" height="500" loading="lazy"></div>`
                    ).join("");
                }
                initSwiperInstance();
            }

            // Exact match on the full combination (all selected options),
            // not "any option equals any one selected value" — with more
            // than one fieldset now, the old any-match check would happily
            // match a variant on Carat alone while ignoring Material.
            const match = variants.find(v => {
                const opts = [v.option1, v.option2, v.option3]
                    .filter(o => o != null)
                    .map(o => String(o).trim().toLowerCase());
                return opts.length === selectedValues.length &&
                    opts.every((o, i) => o === selectedValues[i].toLowerCase());
            });
            if (match) {
                // Mirrors updatePriceUI() in assets/variant_change.js — the price
                // row here is rendered by the same snippets/price.liquid, so it
                // needs the same .price/.price__sale/.price__regular updates.
                const container = priceRow ? priceRow.querySelector(".price") : null;
                if (container) {
                    const price = Number(match.price || 0);
                    const compareAtPrice = Number(match.compare_at_price || 0);

                    const salePriceEl =
                        container.querySelector(".price__sale .price-item--sale.price-item--last") ||
                        container.querySelector(".price__sale .price-item--sale");
                    const comparePriceEl =
                        container.querySelector(".price__sale .price-item--regular") ||
                        container.querySelector(".price__regular .price-item--regular") ||
                        container.querySelector(".price__regular .price-item");
                    const regularOnlyPriceEl =
                        container.querySelector(".price__regular .price-item") ||
                        container.querySelector(".price-item--regular");

                    if (compareAtPrice > price) {
                        container.classList.add("price--on-sale");
                        if (salePriceEl) salePriceEl.textContent = fmt(price);
                        if (comparePriceEl) {
                            comparePriceEl.textContent = fmt(compareAtPrice);
                            comparePriceEl.classList.remove("hidden");
                        }
                    } else {
                        container.classList.remove("price--on-sale");
                        if (regularOnlyPriceEl) regularOnlyPriceEl.textContent = fmt(price);
                        if (salePriceEl) salePriceEl.textContent = fmt(price);
                        if (comparePriceEl) {
                            comparePriceEl.textContent = "";
                            comparePriceEl.classList.add("hidden");
                        }
                    }
                }
                if (viewDetailsBtn) viewDetailsBtn.href = `${viewDetailsBtn.href.split("?")[0]}?variant=${match.id}`;

                // Keep <product-form>'s hidden id input + submit button in
                // sync with whichever combination is now selected, same as
                // variant_change.js does on the product page.
                if (variantIdInput) {
                    variantIdInput.value = match.id;
                    variantIdInput.disabled = false;
                }
                if (addToCartBtn) {
                    addToCartBtn.disabled = !match.available;
                    const span = addToCartBtn.querySelector("span");
                    if (span) {
                        span.textContent = match.available
                            ? (window.variantStrings?.addToCart || "Add to cart")
                            : (window.variantStrings?.soldOut || "Sold out");
                    }
                }
            } else {
                // No variant resolves for the current combination (eg. a
                // required option not yet picked) — disable Add to Cart
                // rather than letting it submit a stale/wrong variant id.
                if (variantIdInput) variantIdInput.disabled = true;
                if (addToCartBtn) addToCartBtn.disabled = true;
            }
        };

        if (preselectValue) {
            body.querySelectorAll('input[type="radio"]').forEach(r => {
                if (r.value === preselectValue) r.checked = true;
            });
        }

        // INP: applyValue() rebuilds the grid + swiper-wrapper HTML
        // synchronously — undebounced, that ran directly inside the
        // radio's own 'change' event, blocking whatever paint would
        // otherwise show the swatch's own selected-state first. This
        // feature is currently disabled (see the commented-out
        // openCardProductQuickView() call in the click listener below) —
        // fixed here anyway so it's ready whenever it's turned back on.
        // Mirrors the same 300ms debounce variant_change.js already uses
        // for the equivalent swatch → gallery rebuild on the product page.
        // Carat's real <select> fires its own 'change' too (dispatched by
        // custom-select.js when a dropdown option is clicked) — Ring
        // Size's hidden input is deliberately not included here, since
        // it's a line-item property, not a variant option.
        let applyValueTimer = null;
        optionContainers().forEach(el => {
            el.querySelectorAll('input[type="radio"], select').forEach(input => {
                input.addEventListener("change", () => {
                    clearTimeout(applyValueTimer);
                    applyValueTimer = setTimeout(() => applyValue(), 300);
                });
            });
        });

        // Options with multiple values don't get auto-checked by
        // product-variant-options.liquid on their own (only single-value
        // options do) — make sure every option container has a value
        // selected so the popup opens already matching a real variant,
        // same as the product page does. A <select> always has some
        // value by default, so only radio-based containers need the
        // explicit fallback-check.
        let hasAnyRadio = false;
        optionContainers().forEach(el => {
            let checkedInput = el.querySelector('input[type="radio"]:checked, select');
            if (!checkedInput) {
                checkedInput = el.querySelector('input[type="radio"]');
                if (checkedInput) checkedInput.checked = true;
            }
            if (checkedInput) hasAnyRadio = true;
        });

        if (hasAnyRadio) {
            applyValue();
        } else {
            // No variant options on this product at all, so applyValue()
            // (the only place that was initializing the swiper) never
            // runs — init it here directly on the as-rendered slides.
            initSwiperInstance();
        }

        if (editOpts) setupEditMode();

        function setupEditMode() {
            const formWrap = body.querySelector(".product-form-buttons product-form");
            const updateBtn = body.querySelector("[data-cpqv-update]");
            // setProperty(..., "important"): the theme's own display/width rules
            // on these elements would otherwise beat the [hidden] attribute.
            if (formWrap) formWrap.style.setProperty("display", "none", "important");
            if (viewDetailsBtn) viewDetailsBtn.style.setProperty("display", "none", "important");
            if (!updateBtn) return;
            updateBtn.hidden = false;
            updateBtn.style.setProperty("width", "50%");

            // Liquid's `json` of a properties hash can arrive as [[key, value], ...]
            // — normalise to a plain {key: value} object.
            let baseProps = {};
            const rawProps = editOpts.properties;
            if (Array.isArray(rawProps)) {
                rawProps.forEach((pair) => {
                    if (Array.isArray(pair) && pair.length >= 2) baseProps[pair[0]] = pair[1];
                });
            } else if (rawProps && typeof rawProps === "object") {
                baseProps = rawProps;
            }
            Object.keys(baseProps).forEach((name) => {
                const val = baseProps[name];
                if (val === "" || val == null) return;
                body.querySelectorAll(`[name="properties[${CSS.escape(name)}]"]`).forEach((input) => {
                    // Ring Size ab radio pills hain — value overwrite nahi,
                    // matching pill ko checked karo
                    if (input.type === "radio") {
                        input.checked = input.value === String(val);
                        return;
                    }
                    input.value = val;
                    const select = input.closest(".product-form__input")?.querySelector(".custom-select");
                    if (!select) return;
                    const label = select.querySelector(".custom-select__value");
                    if (label) label.textContent = val;
                    select.querySelectorAll(".custom-select__option").forEach((li) => {
                        li.classList.toggle("is-selected", li.dataset.value === String(val));
                    });
                });
            });
            // Cart item ka saved Ring Size pill select hua — label + scroll sync
            if (body._cpqvSyncRingSize) body._cpqvSyncRingSize(true);

            updateBtn.addEventListener("click", async () => {
                const ringRadios = body.querySelectorAll('[name="properties[Ring Size]"]');
                const ringChecked = body.querySelector('[name="properties[Ring Size]"]:checked');
                if (ringRadios.length && !ringChecked) {
                    const err = body.querySelector(".ring-size-picker__error");
                    if (err) err.hidden = false;
                    return;
                }

                const selectedValues = getSelectedValues().map((v) => v.toLowerCase());
                const match = variants.find((v) => {
                    const opts = [v.option1, v.option2, v.option3]
                        .filter((o) => o != null)
                        .map((o) => String(o).trim().toLowerCase());
                    return opts.length === selectedValues.length && opts.every((o, i) => o === selectedValues[i]);
                });
                if (!match || !match.available) return;

                const props = { ...baseProps };
                body.querySelectorAll('[name^="properties["]').forEach((input) => {
                    // radio pills (Ring Size): sirf selected wala
                    if (input.type === "radio" && !input.checked) return;
                    const m = input.name.match(/^properties\[(.*)\]$/);
                    if (m && input.value !== "") props[m[1]] = input.value;
                });

                const originalLabel = updateBtn.textContent;
                updateBtn.disabled = true;
                updateBtn.textContent = "Updating...";

                try {
                    // Add the new selection first, then drop the old line, so a
                    // failed add never loses the item from the cart.
                    const addRes = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: match.id, quantity: editOpts.qty || 1, properties: props }),
                    });
                    if (!addRes.ok) throw new Error("add failed: " + addRes.status);
                    const added = await addRes.json();

                    // Same variant + properties merges into the existing line
                    // (same key) — nothing to remove in that case.
                    if (added.key !== editOpts.key) {
                        const removeRes = await fetch("/cart/change.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ id: editOpts.key, quantity: 0 }),
                        });
                        if (!removeRes.ok) throw new Error("remove failed: " + removeRes.status);
                    }
                } catch (err) {
                    console.error("[error CPQV] update error:", err);
                    updateBtn.disabled = false;
                    updateBtn.textContent = originalLabel;
                    return;
                }

                closeModal();
                document.dispatchEvent(new Event("custom:cart:added"));
            });
        }
    }

    // Called from the cart drawer's edit (pencil) button.
    window.errorOpenCartItemEdit = function (opts) {
        if (!opts || !opts.handle) return;
        openCardProductQuickView(opts.handle, null, opts);
    };

    /* Clicking a card that has a Stone Colour option opens the quick view
       instead of navigating straight to the product page; cards without
       one keep the normal <a href> redirect untouched. */
    document.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if (!link) return;
        const wrap = link.closest("[data-stone-colour-handle]");
        if (!wrap) return;
        // Quick view disabled — preventDefault/stopPropagation commented
        // out too (not just the call below), since blocking the click was
        // what stopped the link's own normal navigation from happening at
        // all. With both commented, the <a> just does what it would have
        // done with no listener here: a plain redirect.
        // e.preventDefault();
        // e.stopPropagation();
        // openCardProductQuickView(wrap.dataset.stoneColourHandle);
    });

    /* The quick-view icon button on product cards (card-product.liquid /
       error-card-product-quick-view.liquid) — independent of the
       stone-colour trigger above, and always active. */
    document.addEventListener("click", (e) => {
        const trigger = e.target.closest(".open-quick-view");
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();

        const handle = trigger.dataset.productHandle;
        if (!handle) return;
        openCardProductQuickView(handle);
    });

    /* Material's "+/-" more-options toggle — same behaviour as the
       .plus-minus-button handler in variant_change.js, but that file only
       loads on the actual product page template, not here. Scoped to
       .error-cpqv-modal/.error-vedit-modal specifically so this never
       also fires (and double-toggles) the real product page's own
       plus-minus button on pages where both scripts are loaded. */
    function toggleMaterialMore(btn) {
        const wrapper = btn.nextElementSibling;
        if (!wrapper || !wrapper.classList.contains("material-more-options")) return;
        const isOpen = wrapper.classList.toggle("is-open");
        btn.classList.toggle("is-open", isOpen);
        btn.setAttribute("aria-expanded", String(isOpen));
    }

    document.addEventListener("click", (e) => {
        const btn = e.target.closest(".error-cpqv-modal .plus-minus-button, .error-vedit-modal .plus-minus-button");
        if (!btn) return;
        e.preventDefault();
        toggleMaterialMore(btn);
    });

    document.addEventListener("keydown", (e) => {
        if (e.key !== "Enter" && e.key !== " ") return;
        const btn = e.target.closest(".error-cpqv-modal .plus-minus-button, .error-vedit-modal .plus-minus-button");
        if (!btn) return;
        e.preventDefault();
        toggleMaterialMore(btn);
    });
})();
